"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectService = void 0;
var _utils = require("../../utils");
var redirectService = function () {
  var redirectTo = function redirectTo(targetResource) {
    window.location.href = targetResource;
  };
  var redirectToSignIn = function redirectToSignIn(redirectBackTo) {
    var signInUrl = (0, _utils.getSignInUrl)();
    var redirectToUrl = redirectBackTo ? "".concat(signInUrl, "?redirectTo=").concat(redirectBackTo) : signInUrl;
    return redirectTo(redirectToUrl);
  };
  var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK() {
    return window.history.replaceState({}, document.title, window.location.pathname);
  };
  return {
    DEFAULT_REDIRECT_CALLBACK: DEFAULT_REDIRECT_CALLBACK,
    redirectToSignIn: redirectToSignIn,
    redirectTo: redirectTo
  };
}();
exports.redirectService = redirectService;